<mat-expansion-panel class="threshold-based-coloring-selection">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="me-2 material-icons-outlined">palette</mat-icon>
      {{ 'system.dialogSection.coloringThresholds' | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="d-flex gap-10">
    <mat-form-field appearance="outline" class="value-input">
      <mat-label>{{ 'field.upperThreshold' | translate }}</mat-label>
      <input matInput type="number" [formControl]="inputsFormGroup.controls.upperThreshold" />
    </mat-form-field>

    <mat-dropdown
      class="color-dropdown"
      [formControl]="inputsFormGroup.controls.upperThresholdColor"
      [options]="colorDropdownOptions"
      [configurationInput]="colorDropdownSettings"
      [isFormSubmitted]="isFormSubmitted()"
    ></mat-dropdown>
  </div>
  <div class="d-flex gap-10">
    <mat-form-field appearance="outline" class="value-input">
      <mat-label>{{ 'field.lowerThreshold' | translate }}</mat-label>
      <input matInput type="number" [formControl]="inputsFormGroup.controls.lowerThreshold" />
    </mat-form-field>

    <mat-dropdown
      class="color-dropdown"
      [formControl]="inputsFormGroup.controls.lowerThresholdColor"
      [options]="colorDropdownOptions"
      [configurationInput]="colorDropdownSettings"
      [isFormSubmitted]="isFormSubmitted()"
    ></mat-dropdown>
  </div>
</mat-expansion-panel>
